"use strict";
/**
 *  emphasisSentimentModule
 *
 * Description 策划中心 信息监控 实时线索 重点舆情
 * author: Qian.qianchen 2019-01-17
 */
angular.module('emphasisSentimentModule', [])
    .controller('emphasisSentimentController', ["$scope", "modalDialog", "trsHttpService", "$q", "$state",
        function($scope, modalDialog, trsHttpService, $q, $state) {
            initStatus();
            initData();
            /**
             * [initStatus description]状态初始化
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.status = {
                    emphasisNav: angular.isDefined($state.params.nav) ? $state.params.nav : 'criticalfocus',
                    page: {
                        PAGESIZE: 20,
                        CURRPAGE: 0,
                        ITEMCOUNT: 0,
                        PAGECOUNT: 0
                    },
                    copyCurrPage: 0,
                }
                $scope.data = {
                    arrData: []
                }
            }
            /**
             * [initData description]数据初始化
             * @return {[type]} [description]
             */
            function initData() {
                requestData();
            }
            /**
             * [requestData description] 数据请求
             * @return {[type]} [description]
             */
            function requestData() {
                var defer = $q.defer();
                var params = {
                    'modelid': $scope.status.emphasisNav == 'criticalfocus' ? 'keysentiments' : 'breaksentiments',
                    'serviceid': 'customsentiment',
                    'page_no': $scope.status.page.CURRPAGE,
                    'page_size': $scope.status.page.PAGESIZE,
                    'flag': 0
                }
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "get")
                    .then(function(data) {
                        $scope.data.arrData = data.PAGEITEMS;
                        $scope.status.page.CURRPAGE = data.PAGEINDEX + 1;
                        $scope.status.page.PAGESIZE = data.PAGESIZE;
                        $scope.status.page.ITEMCOUNT = data.TOTALITEMCOUNT;
                        $scope.status.page.PAGECOUNT = data.PAGETOTAL;
                        defer.resolve(data);
                    });
                return defer.promise;
            }
            /**
             * [selectNav description] tab切换
             * @param  {[type]} nav [description]
             * @return {[type]}     [description]
             */
            $scope.selectNav = function(nav) {
                if ($scope.status.emphasisNav == nav) {
                    return;
                }
                $scope.status.emphasisNav = nav;
                $scope.status.page.PAGESIZE = 20;
                $scope.status.page.ITEMCOUNT = 0;
                $scope.status.page.PAGECOUNT = 0;
                $scope.status.page.CURRPAGE = 0;
                requestData();
            }
            /*跳转指定页面*/
            $scope.jumpToPage = function() {
                if ($scope.status.copyCurrPage > $scope.status.page.PAGECOUNT) {
                    $scope.status.copyCurrPage = $scope.status.page.PAGECOUNT;
                }
                $scope.status.page.CURRPAGE = $scope.status.copyCurrPage;
                requestData();
            };
            /**
             * [pageChange description] 分页点击触发方法
             * @return {[type]} [description]
             */
            $scope.pageChange = function() {
                $scope.status.page.CURRPAGE--;
                requestData();
            }
        }
    ]);